import { RouteProps } from "react-router-dom"
import Loadable from "../common/component/Loadable"

export interface AuthorityRouteProps extends RouteProps {
  requiredAuth?: boolean
}

export const routes: AuthorityRouteProps[] = [
  {
    path: "/",
    exact: true,
    component: Loadable(() => import("../routes/Home")),
    requiredAuth: false,
  },
  {
    path: "/marketservice",
    exact: true,
    component: Loadable(() => import("../routes/MarketService")),
    requiredAuth: false,
  },
  {
    path: "/bi",
    exact: true,
    component: Loadable(() => import("../routes/BI")),
    requiredAuth: false,
  },
  {
    path: "/zhixuan",
    exact: true,
    component: Loadable(() => import("../routes/ZhiXuan")),
    requiredAuth: false,
  },
  {
    path: "/logout",
    exact: true,
    component: Loadable(() => import("../routes/Passport/Logout")),
    requiredAuth: false,
  },
  {
    path: "/finance",
    exact: true,
    component: Loadable(() => import("../routes/Finance")),
    requiredAuth: false,
  },
  {
    path: "/retail",
    exact: true,
    component: Loadable(() => import("../routes/Retail")),
    requiredAuth: false,
  },
  {
    path: "/filecenter",
    exact: true,
    component: Loadable(() => import("../routes/FileCenter")),
    requiredAuth: false,
  },
  {
    path: "/saasfile",
    exact: true,
    component: Loadable(() => import("../routes/SaasFile")),
    requiredAuth: false,
  },
  {
    path: "/apicenter",
    exact: true,
    component: Loadable(() => import("../routes/Apicenter")),
  },
  {
    path: "/wzhelpcenter",
    exact: true,
    component: Loadable(() => import("../routes/HelpCenter")),
    requiredAuth: false,
  },
  {
    path: "/wzhelpcenter",
    exact: true,
    component: Loadable(() => import("../routes/HelpCenter")),
    requiredAuth: false,
  },
  {
    path: "/park",
    exact: true,
    component: Loadable(() => import("../routes/Park")),
    requiredAuth: false,
  },
  {
    path: "/aboutus",
    exact: true,
    component: Loadable(() => import("../routes/AboutUs")),
    requiredAuth: false,
  },
  {
    path: "/news",
    exact: true,
    component: Loadable(() => import("../routes/News")),
    requiredAuth: false,
  },
  {
    path: "/privacy",
    exact: true,
    component: Loadable(() => import("../routes/Privacy")),
    requiredAuth: false,
  },
]
